import React, { useContext, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import Responsive from 'components/common/Responsive';
import Button from 'components/common/Button';
import SubInfo from 'components/common/SubInfo';
import Pagination from './Pagination';
import Tags from '../components/common/Tags';
import palette from 'lib/styles/palette';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import client from 'api/WookAxios';
import PostContext from 'post/PostContext';
import { AiOutlineRead } from 'react-icons/ai';
import { AiOutlineLike } from 'react-icons/ai';
import { AiOutlineDislike } from 'react-icons/ai';
import { AiFillHeart } from 'react-icons/ai';
import { AiOutlineHeart } from 'react-icons/ai';
import userEvent from '@testing-library/user-event';
import UserContext from 'user/UserContext';
import log from 'loglevel';
import { PostReactions } from './PostReactions';

const PostListBlock = styled(Responsive)`
  margin-top: 2rem;
  box-sizing: border-box;
  padding-left: 1rem;
  padding-right: 1rem;
  // background: red;

  overflow-y: auto;
`;

const WritePostButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
`;

const PostItemBlock = styled.div`
  // background: tan;
  padding-top: 2.5rem;
  padding-bottom: 1rem;
  
  &:first-child {
    padding-top: 0;
  }

  & + & {
    border-top: 1px solid ${palette.gray[2]};
  }

  h2 {
    font-size: 2rem;
    margin-bottom: 0;
    margin-top: 0;
    &:hover {
      color: ${palette.gray[6]};
    }
    p {
      margin-top: 2rem;
    }
  }
`;

const TitleBlock = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  cursor: pointer;
`;

const CommentCount = styled.div`
  font-size: 20px;
  margin-left: 10px;
  color: ${palette.gray[7]};
`;

const PostReactionsContainer = styled.div`
  // display: flex;
  // align-items: center;
  margin-top: 5px;
  display: flex;
  /* background: lightgray; */
`;

const ViewsSection = styled.div`
  margin-right: 15px;
  color: ${palette.gray[6]};
  display: flex;
  align-items: center;
  // background: lightgray;
`;

const LikesSection = styled.div`
  color: deeppink;
  display: flex;
  align-items: center;
`;

const DislikesSection = styled.div`
  color: deeppink;
  display: flex;
  align-items: center;
  margin-left: 20px;
`;

const HeartsSection = styled.div`
  display: flex;
  align-items: center;
  color: deeppink;
  margin-left: 20px;
`;

// const PostItem = ({ post }) => {
const PostItem = ({ post, currentPage }) => {
  const { title, content, author_name, created_at, views, comments } = post;
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  
  const handleTitle = async () => {
    // sessionStorage.setItem('scrollY', window.scrollY);
    // navigate(`/posts/${post.id}`);
    navigate(`/posts/${post.id}`, { state: { from: `/postlist?page=${currentPage}`}});

    if (user.id === post.author) {
      return
    }

    try {
      const response = await client.increasePostView(post.id);
      log.debug('POST_VIEW_INCREASED', response);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <PostItemBlock>
      <TitleBlock>
        <Title onClick={handleTitle}><h2>{title}</h2></Title>
        <CommentCount>[{post.comments_count}]</CommentCount>
      </TitleBlock>
      <SubInfo username={author_name ? author_name : "탈톼한 사용자"} publishedDate={created_at} />
      <PostReactionsContainer>
        <ViewsSection><AiOutlineRead size="20px" style={{ marginRight: "5px", marginTop: "2px" }}/>{views}</ViewsSection>
        <LikesSection><AiOutlineLike size="20px" style={{ marginRight: "5px" }} />{post.likes}</LikesSection>
        <DislikesSection><AiOutlineDislike size="20px" style={{ marginRight: "5px" }} />{post.dislikes}</DislikesSection>
        <HeartsSection><AiOutlineHeart size="20px" style={{ marginRight: "5px" }} />{post.hearts}</HeartsSection>
      </PostReactionsContainer>
    </PostItemBlock>
  );
};

const PostList = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const currentPage = searchParams.get('page') || 1;
  const [posts, setPosts] = useState([]);
  const { post, setPost } = useContext(PostContext);
  const [pages, setPages] = useState({
    count: 0,
    total_pages: 0,
    current_page: 1,
    next: null,
    previous: null,
  });
  // const reference = useRef(null);
  
  useEffect(() => {
    const getPosts = async () => {
      try {
        const response = await client.getPostsPage(currentPage);
        log.debug('GET_POSTLIST_SUCCESS', response);
        setPosts(response.data.results);
        setPages(response.data);
      } catch(e) {
        log.debug('GET_POSTLIST_FAIELD', e);
      }
    };
    getPosts();

    // const savedY = sessionStorage.getItem('scrollY');
    // if (savedY && listRef.current) {
    //   console.log(savedY);
    //   listRef.current.scrollTop = parseInt(savedY);
    // }

    // return () => {
    //   if (listRef.current) {
    //     sessionStorage.setItem('scrollY', listRef.current.scrollTop);
    //   }
    // }

  // }, [pages.current_page]);
  }, [currentPage]);

  const handleWrite = () => {
    setPost(prev => ({...prev, title: '', content: '', tags: []}));
    navigate('/write');
  };

  return (
    <div className="PostList">
      <PostListBlock>
        <WritePostButtonWrapper>
          <Button color={'pink'} onClick={handleWrite}>
            새 글 작성하기
          </Button>
        </WritePostButtonWrapper>
        {posts && (
          posts.map(post => (
            // <PostItem post={post} key={post.id} />
            <PostItem post={post} key={post.id} currentPage={currentPage}/>
          ))
        )}
        <Pagination pages={pages} />
      </PostListBlock>
    </div>
  );
};

export default PostList;